<script setup>
import { computed, inject } from 'vue';
import { isExternal, styleVars } from './shared.js';
import { orderSponsors, useSponsorSeed } from '../sponsorOrder.js';

const props = defineProps({
    config: { type: Object, required: true },
    accent: { type: String, default: '' },
    org: { type: Object, default: () => ({}) },
    site_data: { type: Object, default: () => ({}) },
});

// Empty: a prompt in the editor, nothing on the live site.
const inEditor = inject('tiqEditorCanvas', false);
const seed = useSponsorSeed();
const items = computed(() => orderSponsors(props.config.items, { random: !! props.config.random_order, inEditor, seed: seed.value }));
</script>

<template>
    <section v-if="items.length || inEditor" :id="config.anchor_id || null" class="th-block th-sec th-spon" :style="styleVars(config)">
        <div class="th-wrap">
            <p class="th-spon__heading">{{ config.heading || 'Supported by' }}</p>

            <div v-if="items.length" class="th-spon__grid">
                <component v-for="(s, i) in items" :key="i"
                           :is="s.href ? 'a' : 'div'"
                           :href="s.href || null"
                           :target="isExternal(s.href) ? '_blank' : null"
                           :rel="isExternal(s.href) ? 'noopener' : null"
                           class="th-spon__cell">
                    <img v-if="s.logo" :src="s.logo" :alt="s.name || ''">
                    <span v-else class="th-spon__name">{{ s.name }}</span>
                </component>
            </div>
            <p v-else class="th-small th-spon__empty">Add sponsors in the editor.</p>
        </div>
    </section>
</template>

<style scoped>
.th-spon__heading {
    font: 500 12px/1 var(--th-mono);
    letter-spacing: .1em;
    text-transform: uppercase;
    color: var(--text-eyebrow, var(--th-meta));
    text-align: center;
    margin: 0 0 24px;
}
.th-spon__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 12px;
}
.th-spon__cell {
    height: 72px;
    border: 1px solid var(--th-line);
    border-radius: var(--r);
    display: grid;
    place-items: center;
    padding: 10px 14px;
    background: #fff;
    text-decoration: none !important;
    transition: border-color .15s ease;
}
a.th-spon__cell:hover { border-color: var(--accent); }
.th-spon__cell img { max-height: 52px; max-width: 100%; object-fit: contain; display: block; }
.th-spon__name {
    font: 700 16px/1.2 var(--th-display);
    text-align: center;
    color: var(--text-sub, var(--th-muted));
    overflow-wrap: anywhere;
}
.th-spon__empty { text-align: center; font-style: italic; }
</style>
